export const buildUrlQueryString = (filterSettings) => {
    const cleanedSettings = isArrayNotEmpty(filterSettings)
        ? { ...filterSettings[0] }
        : { ...filterSettings };

    delete cleanedSettings._editable;
    delete cleanedSettings._uid;
    delete cleanedSettings.component;

    const urlQuery = new URLSearchParams();
    urlQuery.append('isPrefiltered', 'true');

    Object.entries(cleanedSettings).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach((v) => urlQuery.append(key, v));
        } else {
            urlQuery.append(key, value);
        }
    });

    return urlQuery.toString();
};

export const extractUrlQueryString = (urlQuery) => {
    const params = new URLSearchParams(urlQuery);
    const result = {};

    Array.from(params.keys()).forEach((key) => {
        const allValues = params.getAll(key);
        const [firstValue] = allValues;

        if (allValues.length === 1 && (firstValue === 'true' || firstValue === 'false')) {
            result[key] = firstValue === 'true';
        } else if (key === 'textSearch') {
            result[key] = firstValue;
        } else {
            result[key] = allValues;
        }
    });

    return result;
};

export const buildStoryblokQuery = (input, i18n) => {
    if (!input) return {};

    const urlQuery = buildUrlQueryString(input);
    delete urlQuery._storyblok;
    delete urlQuery.isPrefiltered;

    const { locale: currentLocale, defaultLocale } = i18n;
    const suffix = currentLocale.value === defaultLocale || currentLocale.value === 'en' ? '' : `__i18n__${currentLocale.value}`;
    const loadedTags = useNuxtData('cloud-tags')?.data?.value;

    if (!urlQuery) {
        return {};
    }

    const queryObject = extractUrlQueryString(urlQuery);
    const filterQuery = {};

    if (isArrayNotEmpty(queryObject.authors)) {
        filterQuery.author = {
            in: queryObject.authors.join(','),
        };
    }

    if (isArrayNotEmpty(queryObject.countries)) {
        filterQuery.country = {
            in: queryObject.countries.join(','),
        };
    }

    if (isArrayNotEmpty(queryObject.departments)) {
        filterQuery.department = {
            in: queryObject.departments.join(','),
        };
    }

    if (isArrayNotEmpty(queryObject.programs)) {
        filterQuery.program = {
            in: queryObject.programs.join(','),
        };
    }

    if (isArrayNotEmpty(queryObject.regions)) {
        filterQuery.region = {
            in: queryObject.regions.join(','),
        };
    }

    if (isArrayNotEmpty(queryObject.tags)) {
        filterQuery.tags = {
            any_in_array: queryObject.tags.join(','),
        };
    }

    if (isArrayNotEmpty(queryObject.types)) {
        filterQuery.type = {
            in: queryObject.types.join(','),
        };
    }

    if (isArrayNotEmpty(queryObject.years)) {
        const year = queryObject.years[0];
        if (year) {
            filterQuery.manualPublishedDate = {
                gt_date: `${year}-01-01 00:00`,
                lt_date: `${year}-12-31 23:59`,
            };
        }
    }

    if (queryObject.isFoundation) {
        filterQuery.isStiftung = {
            is: 'true',
        };
    }

    if (queryObject.textSearch) {
        if (!filterQuery.__or) {
            filterQuery.__or = [];
        }

        filterQuery.__or.push({
            [`title${suffix}`]: {
                like: `*${queryObject.textSearch}*`,
            },
        });

        filterQuery.__or.push({
            [`lead${suffix}`]: {
                like: `*${queryObject.textSearch}*`,
            },
        });

        const tagIds = [];
        loadedTags.forEach((tag) => {
            if (tag.name.toLowerCase().includes(queryObject.textSearch.toLowerCase())) {
                tagIds.push(tag.uuid);
            }
        });

        if (isArrayNotEmpty(tagIds)) {
            filterQuery.__or.push({
                tags: {
                    any_in_array: tagIds.join(','),
                },
            });
        }
    }

    const { themas } = queryObject;
    if (isArrayNotEmpty(themas) && themas.some((thema) => thema === 'stiftung')) {
        if (!filterQuery.__or) {
            filterQuery.__or = [];
        }

        filterQuery.__or.push({
            isStiftung: {
                is: 'true',
            },
        });
    }

    if (isArrayNotEmpty(themas) && themas.some((thema) => thema === 'schweiz')) {
        if (!filterQuery.__or) {
            filterQuery.__or = [];
        }

        filterQuery.__or.push({
            program: {
                not_like: '',
            },
        });
    }

    if (isArrayNotEmpty(themas) && themas.some((thema) => thema === 'international')) {
        if (!filterQuery.__or) {
            filterQuery.__or = [];
        }

        filterQuery.__or.push({
            country: {
                not_like: '',
            },
        });
    }

    return filterQuery;
};
